import { render } from "./ThemeManagementExamples.vue?vue&type=template&id=c0384fdc&scoped=true&ts=true"
import script from "./ThemeManagementExamples.vue?vue&type=script&lang=ts"
export * from "./ThemeManagementExamples.vue?vue&type=script&lang=ts"

import "./ThemeManagementExamples.vue?vue&type=style&index=0&id=c0384fdc&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0384fdc"]])

export default __exports__